// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"17c247f8","526":"711ad36a"}[chunkId] + ".chunk.js";
};